<template>
    <!-- Title -->
    <div class="o-container">
        <h2 class="o-title-2 c-course__section-title">{{ block.coursesTitle }}</h2>
    </div>
    <!-- Tabs -->
    <div class="c-tabs -course c-course">
        <div v-if="block.coursesBlock.tabs.length > 1" class="c-tabs-nav__wrap" role="tablist">
            <div class="c-tabs-nav-mobile">
                <button class="c-tabs-nav-mobile__button" :class="{ 'disabled': selectedTab <= 0 }" role="tab"
                    @click="toggleTab(selectedTab - 1)">
                    <svg class="o-ico arrow-left" role="img">
                        <title>arrow-left</title>
                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-left"></use>
                    </svg>
                </button>
                <button class="c-tabs-nav-mobile__button"
                    :class="{ 'disabled': selectedTab >= block.coursesBlock.tabs.length - 1 }" role="tab"
                    @click="toggleTab(selectedTab + 1)">
                    <svg class="o-ico arrow-right" role="img">
                        <title>arrow-right</title>
                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-right"></use>
                    </svg>
                </button>
            </div>
            <div class="o-container">
                <div class="c-tabs-nav">
                    <button v-for="(tab, tabIdx) in block.coursesBlock.tabs" :key="'tabs-' + tabIdx"
                        class="c-tabs-nav__item" :class="{ 'is-active': selectedTab == tabIdx }"
                        :aria-selected="selectedTab == tabIdx" role="tab" @click="toggleTab(tabIdx)">
                        <span class="c-tab">
                            <span v-if="false" class="c-tab__suptitle">Programme 7625</span>
                            <span class="c-tab__title">{{ tab.title }}</span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <!-- Content -->
        <div class="c-tabs-content__wrap">
            <div v-for="(tab, tabIdx) in block.coursesBlock.tabs" class="c-tab-content__item"
                :class="{ 'is-active': selectedTab == tabIdx }" :hidden="selectedTab != tabIdx">
                <div class="o-container -container-full">
                    <div class="c-tab-content">
                        <!-- Filters -->
                        <div class="c-course__filter"
                            v-if="block.coursesBlock.tabs[selectedTab].filters !== undefined && block.coursesBlock.tabs[selectedTab].filters.length > 0">
                            <div class="c-course__filter__left">
                                <h3 class="o-title-3">
                                    <!-- Get selected filters values -->
                                    <span v-if="selectedFilter1 !== null">{{
                                        block.coursesBlock.tabs[selectedTab].filters[0].items.find(item => item.id ==
                                            selectedFilter1).label}}</span>
                                    <span v-if="selectedFilter2 !== null"> / {{
                                        block.coursesBlock.tabs[selectedTab].filters[1].items.find(item => item.id ==
                                            selectedFilter2).label}}</span>
                                </h3>
                            </div>
                            <div class="c-course__filter__right">
                                <div class="o-title-5 c-course__filter__title">Filtres</div>
                                <div class="c-course__filter__select">
                                    <div class="o-form__item">
                                        <select class="o-select -bordered -red" v-model="selectedFilter1">
                                            <option
                                                v-for="(item, itemIdx) in block.coursesBlock.tabs[selectedTab].filters[0].items"
                                                :value="item.id">{{ item.label }}</option>
                                        </select>
                                        <svg class="o-ico -ico-arrow-down" role="img">
                                            <title>arrow-down</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                        </svg>
                                    </div>
                                    <div class="o-form__item"
                                        v-if="block.coursesBlock.tabs[selectedTab].filters.length > 1">
                                        <select class="o-select -bordered -red"
                                            v-if="block.coursesBlock.tabs[selectedTab].filters.length > 1"
                                            v-model="selectedFilter2">
                                            <template
                                                v-for="(item, itemIdx) in block.coursesBlock.tabs[selectedTab].filters[1].items">
                                                <option v-if="blockHasFilter2(tab.blocks, item.id)" :value="item.id">{{
                                                    item.label }}</option>
                                            </template>
                                        </select>
                                        <svg class="o-ico -ico-arrow-down" role="img">
                                            <title>arrow-down</title>
                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-for="(blck, blockIdx) in tab.blocks">
                            <div v-if="hasFilter(blck)" class="c-course__row"
                                :class="{ '--note': blck.isNote !== undefined && blck.isNote, '--course': blck.type == 'courses', '--text': blck.type == 'textField' }">
                                <div v-if="blck.type == 'redactor'" class="c-course__text"
                                    :class="{ '--note': blck.isNote !== undefined && blck.isNote }">
                                    <div class="o-text" v-html="blck.value"></div>
                                </div>
                                <div v-if="blck.type == 'textField'" class="c-course__text">
                                    <p v-if="blck.style == 'title'"><strong>{{ blck.value }}</strong></p>
                                    <p v-if="blck.style == 'subtitle'">{{ blck.value }}</p>
                                </div>
                                <div v-if="blck.type == 'courses'" class="c-course__list">
                                    <template v-for="(entry, courseIdx) in blck.value">
                                        <div class="c-course__item">
                                            <a v-if="course(entry).url !== '#'" :href="course(entry).url"
                                                class="c-course__header"
                                                aria-label="Consulter la fiche du cours : Éléments de construction de bâtiment">
                                                <span v-if="entry.course_id !== null" class="c-course__code"
                                                    v-html="course(entry).code + getAsterix(entry)"></span>
                                                <span v-else class="c-course__code"
                                                    v-html="entry.code + getAsterix(entry)"></span>
                                                <span v-if="entry.course_id !== null" class="c-course__name"
                                                    v-html="course(entry).title"></span>
                                                <span v-else class="c-course__name" v-html="entry.title"></span>
                                            </a>
                                            <div v-if="course(entry).url == '#'" class="c-course__header">
                                                <span v-if="entry.course_id !== null" class="c-course__code"
                                                    v-html="course(entry).code + getAsterix(entry)"></span>
                                                <span v-else class="c-course__code"
                                                    v-html="entry.code + getAsterix(entry)"></span>
                                                <span v-if="entry.course_id !== null" class=""
                                                    v-html="course(entry).title"></span>
                                                <span v-else class="" v-html="entry.title"></span>
                                            </div>
                                            <div class="c-course__tags">
                                                <span v-if="entry.course_id !== null" class="c-tag">{{
                                                    course(entry).credits }} crédit<template
                                                        v-if="course(entry).credits > 1">s</template></span>
                                                <span v-else-if="entry.credits !== ''" class="c-tag">{{ entry.credits
                                                }}</span>
                                                <template v-for="(profile, profileIdx) in entry.profiles">
                                                    <span v-if="block.coursesBlock.profiles[profile] !== undefined"
                                                        class="c-tag -bold">
                                                        {{ block.coursesBlock.profiles[profile].title }}
                                                        <span class="c-tooltip">
                                                            <span class="c-tooltip__text">
                                                                <span class="c-tooltip__title">
                                                                    {{ block.coursesBlock.profiles[profile].title }}
                                                                </span>
                                                                <span class="o-p">
                                                                    {{ block.coursesBlock.profiles[profile].description
                                                                    }}
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </template>
                                            </div>
                                            <div v-if="false" class="c-course__prerequisites">
                                                <span class="c-course__prerequisites__title">Préalables</span>
                                                <div class="c-course__code -prerequisite">
                                                    <a aria-label="Consulter la fiche du cours : Méthodes de construction et productivité"
                                                        data-tooltip="Méthodes de construction et productivité"
                                                        href="#"><span>CTN210</span></a>
                                                </div>
                                                <div class="c-course__code -prerequisite">
                                                    <a aria-label="Consulter la fiche du cours : Statique et dynamique"
                                                        data-tooltip="Statique et dynamique"
                                                        href="#"><span>CTN248</span></a>
                                                </div>
                                                <div class="c-course__code -prerequisite">
                                                    <a aria-label="Consulter la fiche du cours : Résistance des matériaux"
                                                        data-tooltip="Résistance des matériaux"
                                                        href="#"><span>CTN318</span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CoursesListing',
    props: ['block'],
    data() {
        return {
            selectedTab: 0,
            selectedFilter1: null,
            selectedFilter2: null,
            courses: [],
            languageUrl: '/',
            refreshUrl: false,
        }
    },
    mounted() {
        // console.log('block: ', this.block);
        let lang = document.documentElement.lang;
        if (lang === 'fr-CA') {
            this.siteId = 1;
        } else {
            this.siteId = 2;
            this.languageUrl = '/en/';
        }
        this.fetchCourses()
        if (this.block.coursesBlock.tabs[this.selectedTab].filters !== undefined && this.block.coursesBlock.tabs[this.selectedTab].filters.length > 0) {
            this.selectedFilter1 = this.block.coursesBlock.tabs[this.selectedTab].filters[0].items[0].id
        }
        if (this.block.coursesBlock.tabs[this.selectedTab].filters !== undefined && this.block.coursesBlock.tabs[this.selectedTab].filters.length > 1) {
            this.selectedFilter2 = this.block.coursesBlock.tabs[this.selectedTab].filters[1].items[0].id
        }
        setTimeout(() => {
            this.refreshUrl = true;
        }, 500);

        // check if url has # this.$el.parentElement.id
        if (window.location.hash) {
            let hash = window.location.hash.substring(1);
            if (hash === this.$el.parentElement.id) {
                let urlParams = new URLSearchParams(window.location.search);
                let tab = urlParams.get('tab');
                let filter1 = urlParams.get('filter1');
                let filter2 = urlParams.get('filter2');
                if (tab !== null) {
                    this.selectedTab = tab;
                }
                if (filter1 !== null) {
                    this.selectedFilter1 = filter1;
                }
                if (filter2 !== null) {
                    this.selectedFilter2 = filter2;
                }
            }
        }
    },
    watch: {
        selectedFilter1: function () {
            this.buildURL();
            setTimeout(() => {
                window.fixLinksTarget();
            }, 0);

            if (this.selectedFilter2 !== null) {
                let hasFilter = false;
                let id = null;

                this.block.coursesBlock.tabs[this.selectedTab].blocks.forEach((block) => {
                    if (block.filters.includes(this.selectedFilter1) && block.filters.includes(this.selectedFilter2)) {
                        hasFilter = true;
                    }
                })

                if (hasFilter === false) {
                    this.selectedFilter2 = null;
                    this.block.coursesBlock.tabs[this.selectedTab].blocks.forEach((block) => {
                        if (this.selectedFilter2 !== null) return;

                        this.block.coursesBlock.tabs[this.selectedTab].filters[1].items.forEach((filter) => {
                            if (this.selectedFilter2 !== null) return;

                            if (block.filters.includes(filter.id) && block.filters.includes(this.selectedFilter1)) {
                                this.selectedFilter2 = filter.id;
                            }
                        })
                    })
                }
            }
        },
        selectedFilter2: function () {
            this.buildURL();
            window.fixLinksTarget();
        }
    },
    methods: {
        toggleTab(id) {
            this.selectedTab = id
            this.selectedFilter1 = null
            this.selectedFilter2 = null

            if (this.block.coursesBlock.tabs[this.selectedTab].filters !== undefined && this.block.coursesBlock.tabs[this.selectedTab].filters.length > 0) {
                this.selectedFilter1 = this.block.coursesBlock.tabs[this.selectedTab].filters[0].items[0].id
            }

            if (this.block.coursesBlock.tabs[this.selectedTab].filters !== undefined && this.block.coursesBlock.tabs[this.selectedTab].filters.length > 1) {
                this.selectedFilter2 = this.block.coursesBlock.tabs[this.selectedTab].filters[1].items[0].id
            }

            let courseLinks = document.querySelectorAll('a[href^="https://www.etsmtl.ca/etudes/cours/"], a[href^="https://www.etsmtl.ca/en/study/courses/"], a[href^="/etudes/cours/"], a[href^="/en/study/courses/"]');
            courseLinks.forEach((link) => {
                link.removeAttribute('target');
                link.removeAttribute('rel');
            });

            this.buildURL();
        },
        fetchCourses() {
            let ids = [];
            this.block.coursesBlock.tabs.forEach(tab => {
                tab.blocks.forEach(block => {
                    if (block.type == 'courses') {
                        block.value.forEach(course => {
                            if (course.course_id !== null) ids.push(course.course_id)
                        })
                    }
                })
            })
            fetch(this.languageUrl + 'api/courses/get?ids=' + ids.join(','), {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    this.courses = data
                })
        },
        course(item) {
            let course = this.courses.find(course => course.id == item.course_id)
            if (!course && item.course_id !== null) {
                course = { id: item.course_id, title: 'Chargement...', url: '#', filters: [], profiles: [] }
            }
            if (item.course_id === null) {
                return item;
            }
            return course
        },
        hasFilter(block) {
            let hasFilter = true;
            let filters = [];
            if (this.selectedFilter1 !== null) filters.push(this.selectedFilter1)
            if (this.selectedFilter2 !== null) filters.push(this.selectedFilter2)

            filters.forEach(filter => {
                if (block.filters === undefined) {
                    hasFilter = false
                } else {
                    if (!block.filters.includes(filter)) hasFilter = false
                }
            })

            return hasFilter
        },
        getAsterix(entry) {
            if (entry.asterix !== undefined) {
                return '<sup class="c-course__code__asterix">' + entry.asterix + '</sup>'
            }

            return '';
        },
        getURL() {
            //let url = '#';
            // append id of vue element
            //url += this.$el.parentElement.id;

            // add selected tab as query param
            let url = '?tab=' + this.selectedTab;

            // add selected filters as query params
            if (this.selectedFilter1 !== null) {
                url += '&filter1=' + this.selectedFilter1;
            }
            if (this.selectedFilter2 !== null) {
                url += '&filter2=' + this.selectedFilter2;
            }
            url += '#' + this.$el.parentElement.id;
            return url;
        },
        buildURL() {
            if (!this.refreshUrl) return;
            let url = this.getURL();
            if (url !== undefined) {
                window.history.replaceState({}, '', url);
            }
        },
        blockHasFilter2(blocks, id) {
            let hasFilter = false
            blocks.forEach((b) => {
                if (b.filters.includes(id) && b.filters.includes(this.selectedFilter1)) hasFilter = true;
            })

            return hasFilter
        }
    }
}
</script>
